import React from "react";
import styled from "styled-components";
import { Facebook, Linkedin, Github, Instagram } from "lucide-react";
import { Link } from "react-scroll";

const FooterContainer = styled.footer`
  background: #111;
  color: #fff;
  padding: 2rem 1.5rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: 1rem;

  @media (min-width: 768px) {
    flex-direction: row;
    justify-content: space-between;
    text-align: left;
    padding: 2rem 3rem;
  }
`;

const NavLinks = styled.div`
  display: flex;
  gap: 1.5rem;
  flex-wrap: wrap;
  justify-content: center;

  a {
    color: #ddd;
    text-decoration: none;
    font-size: 1rem;
    font-weight: 500;
    transition: color 0.3s ease, transform 0.2s;

    &:hover {
      color: #007bff;
      transform: scale(1.05);
    }
  }

  @media (min-width: 768px) {
    justify-content: flex-start;
  }
`;

const SocialIcons = styled.div`
  display: flex;
  gap: 1rem;

  a {
    color: #ddd;
    font-size: 1.4rem;
    transition: color 0.3s ease, transform 0.2s;

    &:hover {
      color: #007bff;
      transform: scale(1.1);
    }
  }
`;

const Copyright = styled.p`
  font-size: 0.9rem;
  color: #aaa;

  @media (min-width: 768px) {
    text-align: right;
  }
`;

function Footer() {
  return (
    <FooterContainer>
      {/* Left - Navigation Links */}
      <NavLinks>
        <Link to="home" smooth={true} duration={500}>
          Home
        </Link>
        <Link to="about" smooth={true} duration={500}>
          About
        </Link>
        <Link to="experience" smooth={true} duration={500}>
          Experience
        </Link>
        <Link to="projects" smooth={true} duration={500}>
          Projects
        </Link>
        <Link to="contact" smooth={true} duration={500}>
          Contact
        </Link>
      </NavLinks>

      {/* Center - Social Media Icons */}
      <SocialIcons>
        <a
          href="https://github.com/Irenemuthoki"
          target="_blank"
          rel="noopener noreferrer"
        >
          <Github size={22} />
        </a>
        <a
          href="https://www.linkedin.com/in/irene-muthoki-1076a7231?"
          target="_blank"
          rel="noopener noreferrer"
        >
          <Linkedin size={22} />
        </a>
        <a
          href="https://www.instagram.com/share/rina_muthoki"
          target="_blank"
          rel="noopener noreferrer"
        >
          <Instagram size={22} />
        </a>
        <a
          href="https://www.facebook.com/share/1B1t6Vw7iu/"
          target="_blank"
          rel="noopener noreferrer"
        >
          <Facebook size={22} />
        </a>
      </SocialIcons>

      {/* Right - Copyright */}
      <Copyright>
        &copy; {new Date().getFullYear()} Irene Muthoki. All Rights Reserved.
      </Copyright>
    </FooterContainer>
  );
}

export default Footer;
